import React from "react";
import { FaShuttleVan } from "react-icons/fa";
import { ImHome } from "react-icons/im";
import { Link } from "react-router-dom";

const Appbar = () => {
  return (
   <>
   <div className="mobile-view">
    <div className="mob-appbar">
      <div className="app-item">
        <div className="logo">Life Style</div>
        <div className="search">
          <input type="text" placeholder="Search..."/>
        </div>
        <div className="right">
          <div>Like</div>
          <div>Cart</div>
        </div>
      </div>
    </div>
   </div>
    <div className="appbar-sec">
      <div className="app-top">
        <div className="appB-left">
        <div className="logo">
          <Link to='/'>
          Life Style
          </Link>
          </div>

          <div className="app-item">
            <FaShuttleVan
              style={{
                fontSize: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "5px",
              }}
            />
            free shipping
          </div>
          <div className="app-item">
            <ImHome
              style={{
                fontSize: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "5px",
              }}
            />
            Click & Collect
          </div>
          <div className="app-item">Return to store</div>
        </div>
        <div className="appB-ceter"></div>
        <div className="appB-right">
          <div className="app-item">Download our Apps</div>
          <div>|</div>
          <div className="app-item">Store location</div>
          <div>|</div>
          <div className="app-item">Help</div>
        </div>
      </div>

      <div className="app-bar">
        <div className="app-logo"></div>
        <div className="app-menu">
          <div className="menu-left">
            <ul>
              <Link to='/'>
              <li>Home </li>
              </Link>
              <Link to='/mens'>
              <li>Men </li>
              </Link>
              <Link to='/woman'>
              <li>Women</li>
              </Link>
            </ul>
          </div>
          <input type="text" placeholder="Search" 
          className="search-input"
          />
          <div className="menu-right">
            <ul>
              <li>More</li>
              <li>Sign Up/Sign In</li>
              <li>like</li>
              <li>cart</li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
   </>
  );
};

export default Appbar;
